
import {PropType} from 'vue';
import {config} from '../../../../src/Config';
import MapElement from './Element/Map.vue';
import IconContactShortBlock from "@app/vue/RenderIcons/IconContactShortBlock.vue";

let _hasTitle = false;

export default {
    components: { IconContactShortBlock, MapElement},
    props: {
        element: {
            type: Object as PropType<object>,
        },
        nameColumn: "default"
    },
    emits: ['applyFilter'],
    methods: {
        checkIsFirstTitleElement(): boolean {
            if (!_hasTitle) {
                _hasTitle = true;
                return true;
            }

            return false;
        },
        executeScript(script) {
            try {
                const func = new Function(script);
                func();
            } catch (err) {
                console.warn(script);
                console.warn(err);
            }
        },
        getClassesBtn(button) {
            return {
                "button": true,
                "button-block button-responsive": this.nameColumn === 'image',
                //"button-xs": button.size === "small",
                "button-xs": true,
                "button-primary": button.style.viewMode === "default",
                "button-second": button.style.viewMode === "light",
            };
        },
        emptyImagePreview() {
            return config.emptyImagePreviewPassport;
        },
        getUrl() {
            return {name: 'main-page'};
        },
        onApplyFilterByTag(tag) {
            this.$emit('applyFilter', this.element.identity, tag.valueId);
        }
    },
    mounted() {
        // JS

    },
}
